// Zelfde regels als de mail (marked met breaks: true): een Enter is een nieuwe regel.
// react-markdown kent die optie niet en toont ruwe HTML als tekst. Daarom vervalt een
// <br> aan het regeleinde (uit eerder opgeslagen teksten) en wordt elke Enter een harde
// regelovergang. Een lege regel blijft een nieuwe alinea.
export const withLineBreaks = (text) =>
  (text ?? '').replace(/<br\s*\/?>[ \t]*(\n|$)/gi, '\n').replace(/\n/g, '  \n')
